import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Form } from "@/components/ui/form";
import { z } from "zod";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import FormInputField from "@/components/lib/from-input-field";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { rejectReservationThunk, clearReservationMessages } from "@/redux/slice/reservation-slice/reservation-slice";

const schema = z.object({
  rejection_reason: z.string().min(1, "Please select a reason"),
  note: z.string().optional(),
});

export default function ReservationRejectDialog({
  isOpen,
  onClose,
  reservation_id,
}) {
  const dispatch = useDispatch();

  const form = useForm({
    resolver: zodResolver(schema),
    mode: "onChange",
    defaultValues: {
      rejection_reason: "",
      note: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      dispatch(clearReservationMessages());
      const res = await dispatch(rejectReservationThunk({ 
        reservation_id, 
        data 
      }));
      
      if (rejectReservationThunk.fulfilled.match(res)) {
        toast.success("Reservation rejected successfully.");
        form.reset();
        onClose();
      } else if (rejectReservationThunk.rejected.match(res)) {
        toast.error(res.payload || "Failed to reject reservation.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] bg-cblack2 border-gray-700 text-cwhite">
        <div className="flex flex-col">
          <DialogTitle className="text-lg font-medium">
            Reservation Reject Reason
          </DialogTitle>
          <Separator className="mt-4 bg-gray-700" />

          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="flex flex-col gap-6 mt-6"
            >
              <FormInputField
                name="rejection_reason"
                style="bg-cblack3"
                placeholder="Select Reason"
                form={form}
                label="Select Reason"
                type="select"
                required={true}
                selectOption={[
                  { label: "Fully Booked", value: "fully_booked" },
                  { label: "No availability at your chosen time", value: "no_availability_time" },
                ]}
              />

              <FormInputField
                name="note"
                style="bg-cblack3 min-h-[100px]"
                placeholder="Write optional note here..."
                form={form}
                label="Note"
                type="textarea"
              />

              <Button 
                type="submit" 
                className="w-full bg-cred hover:bg-cred/90 text-white font-semibold"
              >
                Confirm
              </Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
}
